/**
 * Appointment time formatting.
 *
 * Shared by the dispatch Route column and the Task Details panel so an
 * appointment reads the same way wherever a dispatcher sees it.
 *
 * Format: "Jan/02 18:00" — 24-hour clock, no AM/PM.
 * All Day: "Jan/02 All Day" — the facility gave us a day, not a window.
 */

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const pad2 = (n: number) => String(n).padStart(2, '0')

/** Label shown in place of a clock time on an all-day appointment. */
export const ALL_DAY_LABEL = 'All Day'

/**
 * "Jan/02 18:00", or "Jan/02 All Day" when allDay is set.
 * Returns '' for a missing, pending or unparseable value.
 *
 * All-day rows still carry a real timestamp (anchored to 00:00 local, see
 * migration 174) so date sorting and range filters keep working — the flag is
 * what stops that anchor being shown as a midnight slot.
 */
export function formatApptDateTime(
  dateStr: string | undefined | null,
  allDay?: boolean | null
): string {
  if (!dateStr || dateStr === 'Pending') return ''
  const d = new Date(dateStr)
  if (isNaN(d.getTime())) return ''
  const day = `${MONTHS[d.getMonth()]}/${pad2(d.getDate())}`
  return allDay ? `${day} ${ALL_DAY_LABEL}` : `${day} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`
}

export default formatApptDateTime
